<!-- eslint-disable no-debugger -->
<!-- eslint-disable no-debugger -->
<template>
    <div id="app-container">
        <!-- Intro Menu -->
        <div v-if="gameState === 'intro'" class="intro-menu">
            <h1>Starship <br>vs<br> The Rainbow Brigade</h1>
            <p>
                In a galaxy not so far away, Elon Musk is on a mission to colonize Mars with his shiny Starship. But the
                Democrats have other plans! Armed with rainbow flags and an unhealthy obsession with stopping progress,
                they’re hurling glitter bombs and bad vibes to keep Elon grounded. Dodge their fabulous fury, outwit
                their woke warriors, and get to Mars—or end up at a vegan barbecue instead!
            </p>
            <button @click="startGame" class="play-button">Launch Starship</button>
        </div>
        <!-- Loading Screen -->
        <div v-if="gameState === 'loading'" class="loading-screen">
            <h1>Fueling the Starship...</h1>
            <p>Elon’s packing the Teslaquila while the Democrats try to sneak kale into the cargo bay. Hang tight!</p>

        </div>
        <div v-if="gameState === 'playing' || gameState === 'loading'" class="game-wrapper">
            <div id="game-container" ref="gameContainer"></div>
            <div class="touch-controls">
                <button @touchstart="startMove('left')" @touchend="stopMove('left')"
                    class="control-button left">◄</button>
                <button @touchstart="startMove('right')" @touchend="stopMove('right')"
                    class="control-button right">►</button>
                <button @touchstart="startMove('up')" @touchend="stopMove('up')" class="control-button up">▲</button>
                <button @touchstart="startMove('down')" @touchend="stopMove('down')"
                    class="control-button down">▼</button>
            </div>
        </div>

        <!-- Outro Screen -->
        <div v-if="gameState === 'outro'" class="outro-screen">
            <h1>{{ isWon ? 'Mars Secured!' : 'Mission Aborted!' }}</h1>
            <p v-if="isWon">
                Congratulations, you’ve landed on Mars! Elon’s sipping Teslaquila, tweeting memes from the Red Planet,
                while the Democrats are back on Earth, crying into their kale smoothies. You’ve dodged their rainbow
                rants and proved that nothing stops the Musk Machine—not even a glitter-storm of good intentions!
            </p>
            <p v-else>
                Oh no! The Democrats got you with a rainbow flag to the thrusters! Elon’s grounded, tweeting angrily
                about cancel culture, while the woke warriors celebrate with a tofu ticker-tape parade. Better luck next
                time—maybe try bribing them with free Teslas?
            </p>
            <button @click="restartGame" class="restart-button">Try Again</button>
        </div>
    </div>
</template>

<script>
import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
let scene = null
let camera = null
let renderer = null
let audioListener = null
let starship = null
let mars = null
let people = []
let flags = []
let clock = null
let keys = {
    left: false,
    right: false,
    up: false,
    down: false,
}
let starshipSpeed = 10
let flagSpeed = 20
let spawnInterval = 1000
let spawnDistance = 100
let chaseDistance = 100
let chaseSpeed = 2
let marsDistance = 800
let marsRadius = 40
let starshipBounds = { minX: -10, maxX: 10, minY: -10, maxY: 10 }

export default {
    name: 'StarshipGame3D',
    data() {
        return {
            gameState: 'intro', // 'intro', 'playing', or 'outro'
        };
    },
    mounted() {
    },
    beforeUnmount() {
        window.removeEventListener('keydown', this.onKeyDown);
        window.removeEventListener('keyup', this.onKeyUp);
        window.removeEventListener('resize', this.onWindowResize);
    },
    methods: {
        startGame() {
            this.gameState = 'loading';
            this.$nextTick(() => {
                this.initThreeJS();
                this.initGame().then(() => {
                    this.gameState = 'playing';
                    this.animate();
                    window.addEventListener('keydown', this.onKeyDown);
                    window.addEventListener('keyup', this.onKeyUp);
                    window.addEventListener('resize', this.onWindowResize);
                });
            });
        },
        restartGame() {
            this.gameState = 'intro';
            this.isGameOver = false;
            this.isWon = false;
            people = [];
            flags = [];
            if (scene) {
                while (scene.children.length > 0) {
                    scene.remove(scene.children[0]);
                }
            }
        },
        initThreeJS() {
            const container = this.$refs.gameContainer;
            const width = container.clientWidth;
            const height = container.clientHeight;

            // Initialize scene, camera, and renderer
            scene = new THREE.Scene();
            camera = new THREE.PerspectiveCamera(40, width / height, 0.1, 10000);
            audioListener = new THREE.AudioListener();
            camera.add(audioListener);

            renderer = new THREE.WebGLRenderer();
            renderer.setSize(width, height);
            container.appendChild(renderer.domElement);



            renderer.toneMapping = THREE.ACESFilmicToneMapping; // Better contrast
            renderer.toneMappingExposure = 1.0;
            // Add lighting
            const ambientLight = new THREE.AmbientLight(0xffffff, 0.8); // Brighter ambient
            scene.add(ambientLight);

            const directionalLight = new THREE.DirectionalLight(0xffffff, 2.0); // Stronger sunlight
            directionalLight.position.set(0, 10, 10);
            scene.add(directionalLight);

            const pointLight = new THREE.PointLight(0xffffff, 2.0, 1000); // Brighter point light
            pointLight.position.set(0, 0, -50);
            scene.add(pointLight);
        },
        initGame() {
            // Create starship (blue cone)
            // const starshipGeometry = new THREE.ConeGeometry(1, 2, 8);
            // const starshipMaterial = new THREE.MeshBasicMaterial({ color: 0x0000ff });
            // starship = new THREE.Mesh(starshipGeometry, starshipMaterial);
            // starship.position.set(0, 0, 0);
            // scene.add(this.starship);

            let myPromise = new Promise(function (myResolve, myReject) {

                const loader = new GLTFLoader();

                loader.load('models/scene.gltf', function (gltf) {
                    starship = gltf.scene
                    starship.position.setX(5);
                    starship.position.setY(5);
                    starship.position.setZ(0);
                    starship.scale.set(0.005, 0.005, 0.005);
                    starship.rotation.x = -30;
                    starship.rotation.y = Math.PI / 2;
                    starship.traverse((child) => {
                        if (child.isMesh) {
                            console.log('Material:', child.material); // Log materials for debugging

                            // Ensure the material supports lighting (convert MeshBasicMaterial to MeshStandardMaterial)
                            if (child.material instanceof THREE.MeshBasicMaterial) {
                                child.material = new THREE.MeshStandardMaterial({
                                    map: child.material.map, // Preserve texture
                                    color: child.material.color, // Preserve color
                                    metalness: 0.7, // Add some metallicity (adjust as needed)
                                    roughness: 0.3, // Add some roughness (adjust as needed)
                                    side: THREE.DoubleSide,
                                });
                                child.geometry.computeVertexNormals();
                            }
                        }
                    });
                    scene.add(starship);

                    // Create Mars with texture
                    const SpaceTextureLoader = new THREE.TextureLoader();
                    SpaceTextureLoader.load('/img/space.jpg',
                        (spaceTexture) => {

                            // Create a plane for the background
                            const aspectRatio = spaceTexture.image ? spaceTexture.image.width / spaceTexture.image.height : width / height;

                            const planeWidth = camera.fov * aspectRatio;
                            const planeHeight = camera.fov * 2;
                            const geometry = new THREE.PlaneGeometry(planeWidth, planeHeight);
                            const material = new THREE.MeshBasicMaterial({
                                map: spaceTexture,
                            });
                            const backgroundPlane = new THREE.Mesh(geometry, material);

                            backgroundPlane.position.set(0, 0, -500);
                            scene.add(backgroundPlane);
                            // Create Mars with texture
                            const MarsTextureLoader = new THREE.TextureLoader();
                            const marsTexture = MarsTextureLoader.load('/img/mars_texture.jpg');

                            // Create Mars (orange sphere)
                            const marsGeometry = new THREE.SphereGeometry(marsRadius, 32, 32);
                            const marsMaterial = new THREE.MeshStandardMaterial({
                                map: marsTexture, // Apply the texture
                                metalness: 0.0, // Mars is not metallic
                                roughness: 1.0, // Mars is rough (no specularity)
                                transparent: false,
                                opacity: 1.0,
                            });
                            mars = new THREE.Mesh(marsGeometry, marsMaterial);
                            mars.position.set(0, 0, marsDistance);
                            scene.add(mars);

                            const audioLoader = new THREE.AudioLoader();
                            const soundBufferPromise = new Promise((resolve, reject) => {
                                audioLoader.load('/sounds/crying_democrat.mp3', resolve, undefined, reject);
                            });

                            // Load texture for people sprites
                            const textureLoader = new THREE.TextureLoader();
                            const personTexture = textureLoader.load('/img/democrat.png');

                            // Create people (sprites instead of cylinders)
                            for (let z = 50; z < marsDistance; z += 50) {
                                const personSpriteMaterial = new THREE.SpriteMaterial({
                                    map: personTexture,
                                    transparent: false, // Enable transparency for PNG
                                });
                                const personSprite = new THREE.Sprite(personSpriteMaterial);
                                const position = new THREE.Vector3(
                                    (Math.random() - 0.5) * 20,
                                    (Math.random() - 0.5) * 20,
                                    z
                                );
                                personSprite.position.copy(position);

                                // Scale the sprite (adjust based on your image size)
                                personSprite.scale.set(2, 2, 1); // Width, height, depth (depth is ignored for sprites)

                                scene.add(personSprite);

                                const person = {
                                    mesh: personSprite, // Store the sprite instead of a cylinder
                                    position: position,
                                    spawnTimer: 0,
                                };

                                // Add positional audio to the person
                                soundBufferPromise.then((buffer) => {
                                    person.sound = new THREE.PositionalAudio(audioListener);
                                    person.sound.setBuffer(buffer);
                                    person.sound.setRefDistance(15); // Distance at which volume is full
                                    person.sound.setRolloffFactor(1); // How quickly sound fades with distance
                                    person.sound.setLoop(false); // Loop the sound
                                    personSprite.add(person.sound);
                                }).catch((error) => {
                                    console.error('Error loading sound:', error);
                                });
                                people.push(person);
                            }
                            // Set initial camera position (third-person view)
                            camera.position.set(0, 5, -10);
                            camera.lookAt(0, 0, 0);

                            clock = new THREE.Clock();
                            clock.start();
                            myResolve(); // when successful

                        }, undefined, function (error) {

                            console.error(error);
                            myReject();  // when error

                        }
                    );

                }, undefined, function (error) {

                    console.error(error);
                    myReject();  // when error

                });
            });
            return myPromise

        },
        animate() {
            if (this.gameState === 'playing' && !this.isGameOver && !this.isWon) {
                requestAnimationFrame(this.animate);
                const delta = clock.getDelta();
                this.update(delta);
                this.render();
            } else if (this.isGameOver || this.isWon) {
                this.gameState = 'outro';
            }
        },
        update(delta) {
            // Move starship toward Mars
            starship.position.setZ(starship.position.z + starshipSpeed * delta);

            // Move flags toward the camera
            flags.forEach((flag) => {
                flag.position.z -= flagSpeed * delta;
            });

            // Remove flags that pass the starship
            flags = flags.filter(
                (flag) => flag.position.z > starship.position.z - 10
            );

            // Spawn flags from people when starship is near
            people.forEach((person) => {
                if (
                    Math.abs(starship.position.z - person.position.z) <
                    spawnDistance
                ) {
                    person.spawnTimer -= delta * 1000; // Convert to milliseconds
                    if (person.spawnTimer <= 0) {
                        this.spawnFlag(person.position);
                        person.spawnTimer = spawnInterval;
                        person.position.x = person.position.x
                        if (person.sound && !person.isSoundPlaying && Math.abs(starship.position.z - person.position.z) > 0) {
                            person.sound.play();
                            person.isSoundPlaying = 1;

                        }
                    }
                    // Make person chase the starship if within chaseDistance
                    const distanceToStarship = starship.position.distanceTo(person.position);
                    if (distanceToStarship < chaseDistance) {
                        // Calculate direction to starship in x-y plane
                        const direction = new THREE.Vector3()
                            .subVectors(starship.position, person.position)
                            .setZ(0) // Ignore z (keep person on their original z-plane)
                            .normalize();

                        // Move person toward starship
                        const moveStep = direction.multiplyScalar(chaseSpeed * delta);
                        person.position.add(moveStep);
                        person.mesh.position.copy(person.position);

                        // Update sound position (since person moved)
                        if (person.sound) {
                            person.sound.position.copy(person.position);
                        }
                    }
                    // Play sound if not already playing and person is near
                }
                if (person.position.z - starship.position.z < 0) {
                    // Stop sound if starship moves away
                    person.sound.stop();
                    person.isSoundPlaying = 2;
                    people = people.filter(c => c.mesh != person.mesh)
                    scene.remove(person.mesh);

                }

            });

            // Check collisions with flags
            const starshipBox = new THREE.Box3().setFromObject(starship);
            for (const flag of flags) {
                const flagBox = new THREE.Box3().setFromObject(flag);
                if (starshipBox.intersectsBox(flagBox)) {
                    this.isGameOver = true;
                    break;
                }
            }

            // Check win condition (reaching Mars)
            if (starship.position.z + 20 >= marsDistance - marsRadius) {
                this.isWon = true;
            }

            // Update starship position based on user input
            if (keys.left) {
                starship.position.setX(starship.position.x + starshipSpeed * delta);
            }
            if (keys.right) {
                starship.position.setX(starship.position.x - starshipSpeed * delta);
            }
            if (keys.up) {
                starship.position.setY(starship.position.y + starshipSpeed * delta);
            }
            if (keys.down) {
                starship.position.setY(starship.position.y - starshipSpeed * delta);
            }

            // Keep starship within bounds
            starship.position.setX(Math.max(
                starshipBounds.minX,
                Math.min(starshipBounds.maxX, starship.position.x)
            ));
            starship.position.setY(Math.max(
                starshipBounds.minY,
                Math.min(starshipBounds.maxY, starship.position.y)
            ));

            // Update camera to follow starship (third-person view)
            camera.position.set(
                starship.position.x,
                starship.position.y + 5,
                starship.position.z - 10
            );
            camera.lookAt(
                starship.position.x,
                starship.position.y,
                starship.position.z + 10
            );
        },
        render() {
            renderer.render(scene, camera);
        },
        spawnFlag(position) {

            // Load texture for people sprites
            const textureLoader = new THREE.TextureLoader();
            const flagTexture = textureLoader.load('/img/lgbti_flag.jpg');

            const flagSpriteMaterial = new THREE.SpriteMaterial({
                map: flagTexture,
                transparent: false, // Enable transparency for PNG
            });
            const flag = new THREE.Sprite(flagSpriteMaterial);
            flag.scale.set(2, 1, 1); // Width, height, depth (depth is ignored for sprites)


            flag.position.copy(position);
            scene.add(flag);
            flags.push(flag);
        },
        onKeyDown(event) {
            switch (event.key) {
                case 'ArrowLeft':
                    keys.left = true;
                    break;
                case 'ArrowRight':
                    keys.right = true;
                    break;
                case 'ArrowUp':
                    keys.up = true;
                    break;
                case 'ArrowDown':
                    keys.down = true;
                    break;
            }
        },
        onKeyUp(event) {
            switch (event.key) {
                case 'ArrowLeft':
                    keys.left = false;
                    break;
                case 'ArrowRight':
                    keys.right = false;
                    break;
                case 'ArrowUp':
                    keys.up = false;
                    break;
                case 'ArrowDown':
                    keys.down = false;
                    break;
            }
        },
        startMove(direction) {
            keys[direction] = true;
        },
        stopMove(direction) {
            keys[direction] = false;
        },
        onWindowResize() {
            const container = this.$refs.gameContainer;
            const width = container.clientWidth;
            const height = container.clientHeight;
            camera.aspect = width / height;
            camera.updateProjectionMatrix();
            renderer.setSize(width, height);
        },
    },
};
</script>


<style scoped>
#app-container {
    width: 100vw;
    height: 100dvh;
    overflow: hidden;
    background: linear-gradient(135deg, #1a0d2b, #0d1a3b);
    /* Deep space gradient */
    font-family: 'Orbitron', Arial, sans-serif;
    /* Spacey font */
    position: relative;
    -webkit-user-select: none;
    user-select: none;
}

#app-container::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"><circle cx="10" cy="10" r="1" fill="white" opacity="0.8"/><circle cx="30" cy="40" r="0.5" fill="white" opacity="0.6"/><circle cx="70" cy="20" r="1.5" fill="white" opacity="0.7"/><circle cx="50" cy="80" r="0.8" fill="white" opacity="0.5"/></svg>') repeat;
    opacity: 0.3;
    /* Starfield effect */
    pointer-events: none;
}

.intro-menu,
.loading-screen,
.outro-screen {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    padding: 40px;
    background: rgba(20, 20, 40, 0.9);
    /* Semi-transparent dark space */
    border: 2px solid #ff4500;
    /* Mars orange border */
    border-radius: 15px;
    max-width: 900px;
    box-shadow: 0 0 20px rgba(255, 69, 0, 0.5);
    /* Glowing effect */
    animation: fadeIn 1s ease-in-out;
}


.intro-menu h1,
.loading-screen h1,
.outro-screen h1 {
    font-size: 3em;
    margin-bottom: 25px;
    color: #ff4500;
    /* Mars orange */
    text-transform: uppercase;
    letter-spacing: 2px;
    text-shadow: 0 0 10px #ff4500, 0 0 20px #ff4500;
    /* Neon glow */
    animation: pulse 2s infinite;
}

.intro-menu p,
.loading-screen p,
.outro-screen p {
    font-size: 1.3em;
    line-height: 1.6;
    color: #e0e0e0;
    /* Light gray for readability */
    margin-bottom: 40px;
    animation: slideUp 1s ease-in-out;
}

.play-button,
.restart-button {
    padding: 15px 40px;
    font-size: 1.5em;
    color: #fff;
    background: linear-gradient(45deg, #ff4500, #ff6700);
    /* Orange gradient */
    border: none;
    border-radius: 25px;
    cursor: pointer;
    text-transform: uppercase;
    letter-spacing: 1px;
    box-shadow: 0 5px 15px rgba(255, 69, 0, 0.7);
    transition: transform 0.3s, box-shadow 0.3s;
    -webkit-user-select: none;
    user-select: none;
}

.play-button:hover,
.restart-button:hover {
    transform: scale(1.1);
    box-shadow: 0 10px 25px rgba(255, 69, 0, 1);
}

.touch-controls {
    position: absolute;
    bottom: 10px;
    left: 10px;
    right: 10px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}

.control-button {
    position: absolute;
    width: 70px;
    height: 70px;
    font-size: 2em;
    color: #fff;
    background: rgba(255, 69, 0, 0.8);
    border: none;
    border-radius: 50%;
    cursor: pointer;
    touch-action: manipulation;
    /* Prevent scrolling on touch */
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.5);
    transition: background 0.2s;
    -webkit-user-select: none;
    user-select: none;
    display: flex;
    justify-content: center;
    align-items: center;
}

.control-button:active {
    background: rgba(255, 100, 0, 1);
}

.left {
    left: 0px;
}

.right {
    right: 0px;
}

.up {
    left: 80px;
}

.down {
    right: 80px;
}

#game-container {
    width: 100vw;
    height: 100dvh;
    opacity: 1;
}

.game-wrapper {
    position: relative;
    width: 100vw;
    height: 100dvh;

}

@media screen and (max-width: 600px) {

    .intro-menu h1,

    .loading-screen h1,
    .outro-screen h1 {
        font-size: 1em;
        margin-bottom: 15px;
    }

    .intro-menu p,
    .loading-screen p,
    .outro-screen p {
        font-size: 0.9em;
        line-height: 1.4;
    }

    .intro-menu,
    .loading-screen,
    .outro-screen {
        padding: 20px;
        width: 80vw;
    }

    .play-button,
    .restart-button {
        padding: 15px 40px;
        font-size: 1em;
        color: #fff;
        background: linear-gradient(45deg, #ff4500, #ff6700);
        border: none;
        border-radius: 25px;
        cursor: pointer;
        text-transform: uppercase;
        letter-spacing: 1px;
        box-shadow: 0 1px 5px rgba(255, 69, 0, 0.7);
        transition: transform 0.3s, box-shadow 0.3s;
    }
}

/* Animations */
@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        transform: translateY(20px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes pulse {
    0% {
        text-shadow: 0 0 10px #ff4500, 0 0 20px #ff4500;
    }

    50% {
        text-shadow: 0 0 15px #ff4500, 0 0 30px #ff4500;
    }

    100% {
        text-shadow: 0 0 10px #ff4500, 0 0 20px #ff4500;
    }
}
</style>